<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <b-modal
          id="modal-lg"
          ref="infoModal"
          centered
          size="lg"
          title="Detalle de guia de despacho"
          @ok="waybill = null"
          ok-only
        >
          <div class="text-center">
            <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
          </div>
          <report v-if="waybill" :waybill="waybill"></report>
        </b-modal>
        <h1>Guias de despacho (de salida)</h1>
        <div>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <!--              <b-col>-->
              <!--                <label for="productSelect">Seleccione Producto</label>-->
              <!--                <b-form-select-->
              <!--                  id="productSelect"-->
              <!--                  v-model="selected.product"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.products"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
              <!--              <b-col>-->
              <!--                <label for="conditionSelect">Condición</label>-->
              <!--                <b-form-select-->
              <!--                  id="conditionSelect"-->
              <!--                  v-model="selected.condition"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.conditions"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
              <!--              <b-col>-->
              <!--                <label for="productTypeSelect">Tipo de Producto</label>-->
              <!--                <b-form-select-->
              <!--                  @change="getProductSet"-->
              <!--                  id="productTypeSelect"-->
              <!--                  v-model="selected.product_type"-->
              <!--                  :plain="true"-->
              <!--                  :options="selectOptions.product_types"-->
              <!--                  value="Seleccione...">-->
              <!--                </b-form-select>-->
              <!--              </b-col>-->
            </b-row>
          </b-form>
        </div>
        <hr />
        <v-server-table
          :url="url"
          :columns="columns"
          :options="options"
          :theme="theme"
          ref="table"
          id="dataTable"
        >
          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields2"
              worksheet="Despachos"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-link>Descargar</b-link>
            </download-excel>
          </div>
          <template slot="condition" slot-scope="props">
            <b-badge pill :variant="getBadge(props.row.condition)">{{
              props.row.condition
            }}</b-badge>
          </template>
          <template slot="daystay" slot-scope="props">
            <div style="text-align: right">
              <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
                {{ props.row.daystay }}
              </b-badge>
            </div>
          </template>
          <template slot="afterFilter">
            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner
                v-if="loading"
                variant="primary"
                class="ml-2 mt-1"
                small
                label="Small Spinner"
              ></b-spinner>
            </tr>
          </template>
          <template slot="child_row" slot-scope="props">
            <div><b>Nota productor:</b> {{ props.row.note }}</div>
            <div><b>Nota interna:</b> {{ props.row.internal_note }}</div>
          </template>
          <div slot="total_kilograms" slot-scope="props">
            <div style="text-align: right">
              {{ props.row.total_kilograms.format("0,0.00") }}
            </div>
          </div>
          <div slot="total_pallets" slot-scope="props">
            <div style="text-align: right">{{ props.row.total_pallets }}</div>
          </div>
          <div slot="number" slot-scope="props">
            <div style="text-align: right">{{ props.row.number }}</div>
          </div>
          <div slot="waybill_date" slot-scope="props">
            <div style="text-align: right">{{ props.row.waybill_date }}</div>
          </div>
          <div class="text-right" slot="actions" slot-scope="props">
            <a
              target="_blank"
              href="#"
              @click.prevent="getCompleteWaybill(props.row.id)"
              class="fa fa-lg fa-search text-primary"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="editWaybill(props.row.id)"
              class="fa fa-lg fa-edit text-primary"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
              class="fa fa-lg fa fa-list text-black-50"
              title="Packing List"
            ></a
            >&nbsp;&nbsp;
            <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#"-->
            <!--               class="fa fa-lg fa-trash text-danger"></a>-->
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "../recepcion/Report.vue";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "ListDespacho",
  components: {
    ServerTable,
    Report
  },
  created() {
    this.getProducts();
  },
  mounted() {
    this.loadYear();
  },
  data() {
    return {
      loading: false,
      waybill: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Pallet: "pallet_number",
        Producto: "product_name",
        "Tipo Producto": "product_type_name",
        Condición: "condition",
        Variedad: "variety_name",
        Formato: "container_name",
        Cantidad: "total_pallets",
        "Kg Netos": "total_kilograms",
        "Guía Recepcion": "waybill_number",
        "Fecha Recepción": "waybill_date",
        Estadía: "daystay",
        Specs: "specifications",
        Huerto: "origin_name"
      },
      columns: [
        "client_customer_name",
        "number",
        "company_name",
        "waybill_date",
        "total_pallets",
        "total_kilograms",
        "actions"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        conditions: [
          { value: "", text: "-------" },
          { value: "Orgánico", text: "Orgánico" },
          { value: "Convencional", text: "Convencional" },
          { value: "Org. System Approach", text: "Org. System Approach" },
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(
              results[key].waybill_date
            ).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(
              parseFloat(results[key].total_kilograms)
            );
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          number: "Numero",
          company_name: "Productor",
          client_customer_name: "Exportadora",
          contact_name: "Contacto",
          waybill_date: "Fecha Guia",
          actions: "Acciones",
          total_kilograms: "Kg Netos Totales",
          total_pallets: "Pallets Totales"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Exportadora: "client_customer_name",
        Numero: "number",
        Productor: "company_name",
        "Fecha Guia": "waybill_date",
        "Pallet Total": "total_pallets",
        "Kg Netos Totales": "total_kilograms"
      }
    };
  },
  watch: {
    selected: {
      handler(val) {
        // this.getProductSet(this.selected.product)
      },
      deep: true
    }
  },
  computed: {
    sumMarkedKilograms() {
      let total = 0;
      // total += this.data.reduce((acc, item) => acc + item.total_kilograms.value(), 0);
      total = numeral(total);
      return total;
    },
    url() {
      return (
        "/api/v1/waybill/dispatched_waybills/?" +
        "condition=" +
        this.selected.condition +
        "&product_type=" +
        this.selected.product_type +
        "&variety__product=" +
        this.selected.product +
        "&arrival_month=" +
        this.selected.month +
        "&arrival_year=" +
        this.selected.year
      );
    },
    name() {
      return (
        "ListDespacho " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls"
      );
    }
  },
  methods: {
    async fetchData() {
      const response =
        (await this.$axios.get(
          "/api/v1/waybill/dispatched_waybills/?" +
            "condition=" +
            this.selected.condition +
            "&product_type=" +
            this.selected.product_type +
            "&variety__product=" +
            this.selected.product +
            "&arrival_month=" +
            this.selected.month
        )) +
        "&arrival_year=" +
        this.selected.year;

      return response.data.results;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "Packing List - Guia Despacho #" + a + ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/api/v1/waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, b);
          miniToastr.success(
            "Packing list generado con éxito.",
            "Packing List:"
          );
        })
        .catch(error => {
          miniToastr.error("Problemas al generar packing list", "Error:");
          console.log(error);
        });
    },

    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    getCompleteWaybill(a) {
      this.$refs.infoModal.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete_dispatch/")
        .then(res => {
          this.waybill = res.data;
        })
        .catch(error => console.log(error));
    },
    getBadge(condition) {
      return condition === "Orgánico" ? "primary" : "success";
    },
    getDaystayBadge(daystay) {
      return daystay >= 10
        ? "danger"
        : daystay >= 5
        ? "warning"
        : daystay >= 3
        ? "success"
        : "primary";
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then(res => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch(error => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then(res => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch(error => (this.selected.product_type = ""));
    },
    deleteWaybill(a) {
      console.log(a);
      this.$axios
        .delete("/api/v1/waybill/" + a + "/")
        .then(res => {
          this.$refs.table.refresh();
        })
        .catch(error => console.log(error));
    },
    editWaybill(a) {
      this.$router.push("/despacho/editar/" + a);
    },
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
